var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.env)}}),_vm._v("\n\n  Is userLogged : "+_vm._s(_vm.isUserLogged)+"\n  "),_c('br'),_vm._v("\n  Is userPremium : "+_vm._s(_vm.userSubscription)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }